import Vue from 'vue'
import { Row, Col, Form, Input, Button, Table, message } from 'ant-design-vue'
import ImgCaptcha from '@/components/imgcaptcha'
import Step from '@/components/step'
import './index.less'

Vue.config.productionTip = false
Vue.use(Row)
Vue.use(Col)
Vue.use(Form)
Vue.use(Input)
Vue.use(Button)
Vue.use(ImgCaptcha)
Vue.use(Table)
Vue.use(Step)
Vue.prototype.$message = message
/* eslint-disable no-new */
